import { useMediaQuery } from "@einride/hooks"
import { Saga, SagaNavbar, SagaPage, SagaSidebar } from "@einride/saga-core"
import { useTheme } from "@einride/ui"
import styled from "@emotion/styled"
import { ReactComponent as SidebarSVG } from "assets/drawer.svg"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import {
  SIDEBAR_MIN_WIDTH,
  SIDEBAR_TRANSITION,
  SIDEBAR_WIDTH,
  SidebarIcon,
} from "./DeviceViewContainer/DeviceViewContainer"

interface ShipmentLayoutProps {
  children: ReactNode
  isSplitViewOpen: boolean
  setIsSplitViewOpen: (value: boolean) => void
  actions: React.JSX.Element
  backLink?: string
}

export const ShipmentLayout = ({
  children,
  isSplitViewOpen,
  actions,
  setIsSplitViewOpen,
  backLink,
}: ShipmentLayoutProps): React.JSX.Element => {
  const theme = useTheme()
  const isBelowMd = useMediaQuery(theme.mediaQueries.belowMd)
  const { t } = useTranslation()

  let minWidth = isSplitViewOpen ? SIDEBAR_WIDTH : SIDEBAR_MIN_WIDTH
  if (isBelowMd) {
    minWidth = "0"
  }

  const toggleSidebar = (): void => {
    setIsSplitViewOpen(!isSplitViewOpen)
  }

  return (
    <StyledSaga
      data-testid="report-layout"
      marginRight={minWidth}
      navbar={
        <StyledSagaNavbar
          back={{
            title: t("reportPage.reportsLink"),
            to: backLink || "/reports",
          }}
          actions={actions}
          smActions={
            <SidebarIcon onClick={toggleSidebar}>
              <SidebarSVG />
            </SidebarIcon>
          }
        />
      }
      sidebar={<SagaSidebar />}
    >
      <StyledSagaPage>{children}</StyledSagaPage>
    </StyledSaga>
  )
}

const StyledSaga = styled(Saga)<{ marginRight: string }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-right: ${({ marginRight }) => marginRight};
  transition: margin ${SIDEBAR_TRANSITION};
  @media ${({ theme }) => theme.mediaQueries.lg} {
    height: 100vh;
  }
`

const StyledSagaNavbar = styled(SagaNavbar)`
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colors.background.primary};
`

const StyledSagaPage = styled(SagaPage)<{ headerHeight?: number }>`
  display: flex;
  flex-direction: column;
`
